"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareNumbers = exports.CompatibleCompareNumbersConfig = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
const operators = {
    lessThan: (left, right) => left < right,
    greaterThan: (left, right) => left > right,
    greaterThanOrEqual: (left, right) => left >= right,
    lessThanOrEqual: (left, right) => left <= right,
};
class CompatibleCompareNumbersConfig {
    config;
    operation;
    // Private instance properties allow typescript to ensure that an instance of
    // this class is being used.
    constructor(config) {
        this.config = config;
        this.operation = config.operation;
    }
    ensureCompatibility = (loanTape) => {
        const { field, type, value } = this.config;
        (0, common_1.finleyAssert)(type === typeof value, `Invalid type for config value ${value}. Expected ${type}, got ${typeof value}`);
        const invalidRecord = _.find(loanTape, (record) => {
            const fieldValue = (0, utils_1.getFieldValue)({ loanTape: record, field });
            return !_.isNil(fieldValue) && typeof fieldValue !== type;
        });
        (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({
            invalidRecord,
            field,
            type,
            operationType: this.operation,
        }));
    };
    static create = (config, loanTape) => {
        const obj = new CompatibleCompareNumbersConfig(config);
        obj.ensureCompatibility(loanTape);
        return obj;
    };
}
exports.CompatibleCompareNumbersConfig = CompatibleCompareNumbersConfig;
/*
 * Selects all loanTapes that meet a numerical comparison test
 * example config:
 * {
 *    field: 'gla';
 *    operator: 'lessThan';
 *    value: 50000;
 * }
 *
 */
const compareNumbers = ({ config: { field, value, operation }, }) => (loanTapeRecords) => _.filter(loanTapeRecords, (loanTape) => {
    const fieldValue = (0, utils_1.getFieldValue)({ loanTape, field });
    return _.isNumber(fieldValue) && operators[operation](fieldValue, value);
});
exports.compareNumbers = compareNumbers;
//# sourceMappingURL=compareNumbers.js.map